var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AddIcon from '@mui/icons-material/Add';
import { Alert, Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { CardFuncionario } from '../../../components/Funcionario/CardFuncionario';
import { FuncionarioModalForm } from '../../../components/Funcionario/FuncionarioModalForm';
import { RequestLoadingIndicator } from '../../../components/RequestLoadingIndicator';
import { useWizard } from '../../../components/Wizard/useWizard';
import { WizardButtons } from '../../../components/Wizard/WizardButtons';
import { useProcessContext } from '../context/ProcessContext';
export var FuncionariosForm = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var _c = useWizard(), nextStep = _c.nextStep, prevStep = _c.prevStep;
    var _d = useProcessContext(), processo = _d.processo, servico = _d.servico, analise = _d.analise, addFuncionario = _d.addFuncionario, updateFuncionario = _d.updateFuncionario, deleteFuncionario = _d.deleteFuncionario;
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState(null), modalFuncionarioOpen = _f[0], setModalFuncionarioOpen = _f[1];
    var _g = useState(undefined), selectedFuncionario = _g[0], setSelectedFuncionario = _g[1];
    var funcionarios = processo === null || processo === void 0 ? void 0 : processo.funcionarios;
    var handleOpenAddFuncionario = function () {
        setModalFuncionarioOpen('adicionar');
    };
    var handleOpenEditFuncionario = function (funcionario) {
        setSelectedFuncionario(funcionario);
        setModalFuncionarioOpen('editar');
    };
    var handleOpenViewFuncionario = function (funcionario) {
        setSelectedFuncionario(funcionario);
        setModalFuncionarioOpen('visualizar');
    };
    var handleCloseModal = function () {
        setModalFuncionarioOpen(null);
        setSelectedFuncionario(undefined);
    };
    var handleSaveFuncionario = function (funcionario) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, , 5, 6]);
                    setLoading(true);
                    if (!selectedFuncionario) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateFuncionario(selectedFuncionario.id, funcionario)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, addFuncionario(funcionario)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    setModalFuncionarioOpen(null);
                    setSelectedFuncionario(undefined);
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteFuncionario = function (funcionarioId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, , 2, 3]);
                    setLoading(true);
                    return [4 /*yield*/, deleteFuncionario(funcionarioId)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Box, { children: [_jsx(RequestLoadingIndicator, { loading: loading }), _jsxs(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }, children: [_jsx(Typography, { variant: "h6" }), !disabled && (_jsx(Button, { variant: "contained", color: "primary", startIcon: _jsx(AddIcon, {}), onClick: handleOpenAddFuncionario, children: "Adicionar Funcion\u00E1rio(a)" }))] }), (!funcionarios || funcionarios.length === 0) && (_jsx(Alert, { severity: "warning", sx: { mt: 2 }, children: "Title Voc\u00EA ainda n\u00E3o realizou o cadastro de nenhum Funcion\u00E1rio(a). Clique no bot\u00E3o \"Adicionar Funcion\u00E1rio(a)\" para cadastrar Funcion\u00E1rio(as)." })), !!funcionarios &&
                funcionarios.length > 0 &&
                funcionarios.map(function (funcionario) { return (_jsx(CardFuncionario, { funcionario: funcionario, analise: analise, onOpenEdit: handleOpenEditFuncionario, onOpenView: handleOpenViewFuncionario, onDelete: handleDeleteFuncionario, disabled: disabled }, funcionario.id)); }), !!modalFuncionarioOpen && (_jsx(FuncionarioModalForm, { modo: modalFuncionarioOpen, open: true, funcionario: selectedFuncionario, servico: servico, analise: analise, onClose: handleCloseModal, onSave: handleSaveFuncionario })), _jsx(WizardButtons, { nextClick: function () { return nextStep(); }, prevClick: function () { return prevStep(); } })] }));
};
